// removed by extract-text-webpack-plugin
module.exports = {"root":"_1-OS8Sl","messageContainer":"_17m3q9I","text":"_1ARKzTa","retry":"_2v2NUuh","errorSvg":"_37He8-y"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/HomePage/components/Dashboard/components/SignedInDashboard/components/DashboardError/DashboardError.less
 ** module id = 777
 ** module chunks = 0
 **/